//Channel Airlines Router

const DiscoveryAirlines = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines')
const AirportMedia = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/AirportMedia')
const Lcd = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/AirportMedia/LCD')
const LightBox = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/AirportMedia/LightBox')
const InFlight = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight')
const AirCraft = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight/Aircraft')
const Avod = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight/Avod')
const CheckCounter = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight/CheckCounter')
const Magazine = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight/Magazine')
const MaterialBranding = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight/MaterialBranding')
const Office = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight/Office')
const Sampling = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight/Sampling')
const Wifi = () => import(/* webpackChunkName: "Airlines" */ '../views/Discovery/Airlines/Inflight/Wifi')


const AirlinesRoute = [
    {
      path: '/airlines',
      name: 'airlines',
      component: DiscoveryAirlines,
      meta: { isStaffAirlines: true}
    },
    {
      path: '/airlines/inflight',
      name: 'inflight',
      component: InFlight,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/aircraft/:pub_id',
      name: 'aircraft',
      component: AirCraft,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/avod/:pub_id',
      name: 'avod',
      component: Avod,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/check-counter/:pub_id',
      name: 'checkcounter',
      component: CheckCounter,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/magazine/:pub_id',
      name: 'magazine',
      component: Magazine,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/material-branding/:pub_id',
      name: 'materialbranding',
      component: MaterialBranding,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/office/:pub_id',
      name: 'office',
      component: Office,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/sampling/:pub_id',
      name: 'sampling',
      component: Sampling,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/wifi/:pub_id',
      name: 'wifi',
      component: Wifi,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/airport-media',
      name: 'airportmedia',
      component: AirportMedia,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/airport-media/lcd/:pub_id',
      name: 'lcd',
      component: Lcd,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/airport-media/lightbox/:pub_id',
      name: 'lightbox',
      component: LightBox,
      meta: { isStaff: true }
    },
]

export default AirlinesRoute;
